import React from 'react';
import SEO from '../components/SEO';

const Cookies: React.FC = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Cookie Policy",
    "description": "Cookie policy for ReelVindicator.com"
  };

  return (
    <>
      <SEO
        title="Cookie Policy - ReelVindicator"
        description="Learn about how ReelVindicator.com uses cookies to enhance your browsing experience and provide personalized content."
        schema={schema}
      />

      <div className="pt-20 pb-12">
        <section className="py-12 bg-gradient-to-br from-dark-surface to-dark-bg">
          <div className="container mx-auto px-4">
            <h1 className="text-5xl md:text-6xl font-bold text-center mb-4">
              <span className="text-gradient">Cookie Policy</span>
            </h1>
            <p className="text-gray-400 text-center">Last updated: {new Date().toLocaleDateString()}</p>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4 max-w-4xl">
            <div className="glass p-8 rounded-xl space-y-8">
              <div>
                <h2 className="text-3xl font-bold mb-4">1. What Are Cookies?</h2>
                <p className="text-gray-400 leading-relaxed">
                  Cookies are small text files that are placed on your computer or mobile device when you visit a website. 
                  Cookies are widely used to make websites work more efficiently and provide information to the owners of the site.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">2. How We Use Cookies</h2>
                <p className="text-gray-400 leading-relaxed mb-4">
                  ReelVindicator.com uses cookies to enhance your browsing experience. We use cookies for the following purposes:
                </p>
                <ul className="list-disc list-inside text-gray-400 space-y-2 ml-4">
                  <li><strong>Essential Cookies:</strong> These cookies are necessary for the website to function properly</li>
                  <li><strong>Analytics Cookies:</strong> These cookies help us understand how visitors interact with our website</li>
                  <li><strong>Preference Cookies:</strong> These cookies remember your preferences and settings</li>
                  <li><strong>Marketing Cookies:</strong> These cookies are used to deliver relevant advertisements</li>
                </ul>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">3. Types of Cookies We Use</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-xl font-bold mb-2">Strictly Necessary Cookies</h3>
                    <p className="text-gray-400 leading-relaxed">
                      These cookies are essential for the website to function and cannot be switched off. They are usually set in response to actions 
                      made by you such as setting your privacy preferences, logging in, or filling in forms.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Performance Cookies</h3>
                    <p className="text-gray-400 leading-relaxed">
                      These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. 
                      They help us know which pages are most and least popular.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Functionality Cookies</h3>
                    <p className="text-gray-400 leading-relaxed">
                      These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party 
                      providers whose services we have added to our pages.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Targeting Cookies</h3>
                    <p className="text-gray-400 leading-relaxed">
                      These cookies may be set through our site by our advertising partners. They may be used to build a profile of your interests 
                      and show you relevant adverts on other sites.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">4. Third-Party Cookies</h2>
                <p className="text-gray-400 leading-relaxed">
                  In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the service, 
                  deliver advertisements, and so on. These third-party cookies are governed by the respective privacy policies of those third parties.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">5. Managing Cookies</h2>
                <p className="text-gray-400 leading-relaxed mb-4">
                  You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set 
                  most browsers to prevent them from being placed. However, if you do this, you may have to manually adjust some preferences every 
                  time you visit a site and some services and functionalities may not work.
                </p>
                <p className="text-gray-400 leading-relaxed">
                  Most web browsers allow some control of most cookies through the browser settings. To find out more about cookies, including how 
                  to see what cookies have been set and how to manage and delete them, visit www.allaboutcookies.org.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">6. Changes to This Cookie Policy</h2>
                <p className="text-gray-400 leading-relaxed">
                  We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our business operations. 
                  We will notify you of any changes by posting the new Cookie Policy on this page and updating the "Last updated" date.
                </p>
              </div>

              <div>
                <h2 className="text-3xl font-bold mb-4">7. Contact Us</h2>
                <p className="text-gray-400 leading-relaxed">
                  If you have any questions about our use of cookies, please contact us through our website contact form.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Cookies;

